export default __webpack_public_path__ + "static/media/amazon-imported.f7350778.svg";